import { Tag } from '../typings';
import { ApiContextType } from '../api-context';

export const fetchTags = (api: ApiContextType): Promise<Tag[]> => {
    return api.get('/tags')
        .then(res => {
            if (res.status === 200) {
                return res.json();
            }
            return Promise.reject(res.status);
        });
};

export const updateTagName = (api: ApiContextType, id: number, name: string) => {
    return api.post(`/tag/${id}`, name)
        .then((res) => {
            if (res.status !== 200 && res.status !== 204) {
                return Promise.reject();
            }
            return Promise.resolve();
        });
}

export const removeTag = (api: ApiContextType, id: number) => {
    return api.del(`/tag/${id}`)
        .then((res) => {
            if (res.status !== 200 && res.status !== 204) {
                return Promise.reject();
            }
            return Promise.resolve();
        });
}

export const createTag = (api: ApiContextType, name: string) => {
    return api.put('/tag', name)
        .then((res) => {
            if (res.status !== 200 && res.status !== 204) {
                return res.text().then(t => Promise.resolve(Number(t)));
            }
            return Promise.resolve(0);
        });
}
